import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={3}
      d="m2 2 6.5 6.5M8.5 2 2 8.5"
    />
  </svg>
)
export default SvgComponent
